<template>
  <div id="widget-root" ref="widgetContainer">

    <div id="cdek-map" style="width:650px;height:600px"></div>
  </div>
</template>

<script setup>
import {onMounted, ref, defineEmits} from "vue";
import {useSettingsStore} from "@/store/settings";

const emit = defineEmits(['choosePoint'])

const widgetContainer = ref(null);
const settings = useSettingsStore()

function handleChoose(pointType, a2, pointObject) {
  emit('choosePoint', pointType, pointObject);
}


function initWidget() {
  const yandexApiKey = settings.getOption('YANDEX_PUBLIC_API_KEY');
  new window.CDEKWidget({
    from: 'Москва',
    root: 'cdek-map',
    apiKey: yandexApiKey,
    servicePath: '/api/v1/delivery',
    defaultLocation: 'Москва',
    hideDeliveryOptions: {
      office: false,
      door: true,
    },
    onChoose(a1, a2, a3) {
      console.log('Selected', a1, a2, a3)
      handleChoose(a1, a2, a3);
    }
  });
}

onMounted(() => {
  if (window.CDEKWidget) {
    initWidget();
    return;
  }

  if (document.querySelector('script[src*="cdek-it/widget"]')) {
    const interval = setInterval(() => {
      if (window.CDEKWidget) {
        clearInterval(interval);
        initWidget();
      }
    }, 100);
    return;
  }

  const script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/@cdek-it/widget@3';
  script.async = true;
  script.onload = initWidget;
  document.head.appendChild(script);
});
</script>


<style scoped lang="scss">

</style>
